
import Subscribe from './subscribe/Subscribe'

const Footer = () => {

	return (
		<>
				<Subscribe />
		</>
	)
}

export default Footer
